import React from "react";
import { ParsedPreviewConfig } from "./ParsePreviewConfig";

type Props = {
  parsedPreviewConfig: ParsedPreviewConfig;
};

export const AxMediaPreview: React.FC<Props> = ({ parsedPreviewConfig }) => {
  if (parsedPreviewConfig?.type === "audio") {
    return <audio className="p-2" src={parsedPreviewConfig.url} controls />;
  }

  if (parsedPreviewConfig?.type === "video") {
    return (
      <video className="w-full h-full object-contain object-center" controls>
        <source src={parsedPreviewConfig.url} type="video/mp4" />
      </video>
    );
  }
  if (parsedPreviewConfig?.type === "image") {
    return <img src={parsedPreviewConfig.url} className="w-full h-full object-contain object-center" />;
  }

  if (parsedPreviewConfig?.type === "link") {
    return (
      <div className="w-full h-full p-2 text-xs flex gap-2">
        <iframe src={parsedPreviewConfig.url} name="myiFrame" width="100%" height="100%" allowFullScreen></iframe>
      </div>
    );
  }

  // if (parsedPreviewConfig?.type === "split") {
  //   return (
  //     <div className="w-full h-full p-2 text-xs flex gap-2">
  //       <SplitIcon className="w-4 h-4" /> {parsedPreviewConfig.name}
  //     </div>
  //   );
  // }

  if (parsedPreviewConfig?.type === "doc") {
    const url = new URL(parsedPreviewConfig.url);
    // Add PDF.js viewer parameters
    // #view=FitH - Fit to width
    // &toolbar=0 - Hide toolbar
    // &navpanes=0 - Hide navigation panes/sidebar
    // &scrollbar=0 - Hide scrollbar
    const iframeUrl = `${url.toString()}#view=FitH&toolbar=0&navpanes=0&scrollbar=0`;

    return (
      <div className="w-full h-full p-2 text-xs flex gap-2">
        <iframe src={iframeUrl} style={{ width: "100%", height: "100%", border: "none" }} title="PDF Document Viewer" />
      </div>
    );
  }

  return null;
};
